import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LinkComponent from "../../components/general/LinkComponent";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../../store/slices/userSlice";
import MetaData from "../../components/seo/MetaData";

const UnsuccessfulPage = () => {
  

  return (
    <div className="flex h-[60vh] w-full flex-col items-center justify-center gap-6 bg-white px-4">
      <MetaData
        title={"Payment Unsuccessful | Qbank Model"}
        description={
          "Your payment was Unsuccessful. Please try again or contact support for assistance with your Qbank Model transaction"
        }
        keywords={
          "payment issue, Qbank Model transaction, payment failed, contact support"
        }
      />

      <div className="space-y-2 text-center">
        <h1 className="text-gray-500 text-themeSecondryDark-0">Ops!</h1>
        <p className="text-lg text-gray-500 text-themeSecondryDark-0">
          Due to some errors. Payment was Unsuccessful
        </p>
      </div>

      <LinkComponent to={"/subscriptions"} text={"Go to pricing"} />
    </div>
  );
};

export default UnsuccessfulPage;
